// Interface for meal plan options
export interface MealPlanOption {
  label: string;
  value: string;
}

// Mapping of representative meal plan values to equivalent API values
/*const mealPlanMapping: Record<string, string[]> = {
  "Bed and Breakfast": [
    "Bed and Breakfast",
    "Bed and Breakfast for 2",
    "Bed and Breakfast for 1",
    "Bed and Breakfast for 3",
    "Bed and Breakfast for 4",
    "american-Bed and Breakfast",
    "Breakfast for one guest",
    "Bed and Breakfast for 1 guest",
    "Bed and Breakfast for 2 guests",
    "Bed and Breakfast for 3 guests",
    "Deluxe Single Room With Breakfast",
    "Bed and Breakfast Rate",
    "Deluxe Double Room With Breakfast",
    "Premium Single Room with Breakfast",
    "Meal Plan - Bed and Breakfast",
    "cold buffet-Bed and Breakfast",
    "continental buffet-Bed and Breakfast",
    "hot buffet-Bed and Breakfast",
  ],
  "All Inclusive": [
    "All inclusive",
    "All Inclusion",
    "All inclusions",
    "All inclusive all",
    "All-inclusive (food/beverages/snacks)",
    "Bed and Breakfast-All Inclusion",
  ],
  "Full Board": ["Full Board"],
  "Half Board": ["Half Board", "Bed and Breakfast-Half Board"],
  "Room Only": [
    "Room Only",
    "Room Only - No meal plan",
    "Room Only Promo 1",
    "Deluxe Double Room Only",
    "Room Only 2",
    "Deluxe Single Room Only",
    "Superior Double Room Only",
    "Standard Double Room Only",
    "Executive Single - Room Only",
    "Executive Double Room Only",
    "Room Only Promo 2",
    "Room Only (Room_Only)",
    "Executive Room Only",
    "Room Only|NF",
    "Deluxe Double Room - Room Only",
    "Deluxe Single Room - Room Only",
    "Room Only - NRF",
    "Room Only Promo",
    "Standard Room Only",
    "Boutique Single Room Only",
    "Deluxe AC Double Room - Room Only",
    "Deluxe Twin Double Room - Room Only",
    "Lodhi Standard Room Only",
    "Room Only Excluding Resort Fee",
    "Room Only (No meals)",
    "Superior Twin Bed Room Only",
    "A/C Deluxe Room Only",
    "Budget Single Non AC Room Only",
    "Business Class AC Single Room",
    "Business Room Only",
    "City Deluxe Double Room Only",
    "Classic Room - Room Only",
    "Club Room Room Only"
  ],
};*/
// Mapping of representative meal plan values to equivalent API values
const mealPlanMapping: Record<string, string[]> = {
  "Bed and Breakfast": [
    "Alojamiento & Desayuno",
    "american-Bed and Breakfast",
    "Beachfront Garden View With Breakfast",
    "Beachfront Sea View With Breakfast",
    "Bed & Breakfast (Non-Alcoholic)",
    "Bed and Breakfast",
    "Bed and Breakfast for 1",
    "Bed and Breakfast for 1 guest",
    "Bed and Breakfast for 2",
    "Bed and Breakfast for 2 guests",
    "Bed and Breakfast for 3",
    "Bed and Breakfast for 3 guests",
    "Bed and Breakfast for 4",
    "Bed and Breakfast for 4 guests",
    "Bed and Breakfast Rate",
    // "Bed and Breakfast-All Inclusion",
    "Breakfast Continental",
    "Breakfast For Five",
    "Breakfast For Four",
    "Breakfast For One",
    "Breakfast For Six",
    "Breakfast For Three",
    "Breakfast for one guest",
    "Breakfast For Two",
    "Breakfast for 1",
    "Business Class Single Room with Breakfast",
    "Business Double Room With Breakfast",
    "Business Single Room With Breakfast - MOR",
    "Chanakya Tower Double Room With Breakfast",
    "Chanakya Tower Single Room With Breakfast",
    "City Deluxe Double Room With Breakfast",
    "Classic Double Room With Breakfast",
    "Classic Room With Breakfast",
    "Classic Single Room -Breakfast-MOR",
    "Club Double Premium Room With Breakfast",
    "Club Double Room with Breakfast",
    "Club Room With Breakfast - Double Occupancy",
    "Club Single Premium Room With Breakfast",
    "Club Single Room with Breakfast",
    "cold buffet-Bed and Breakfast",
    "Comfort Double Room With breakfast",
    "Comfort Queen Single Room Breakfast",
    "Compact Room With Breakfast",
    "continental buffet-Bed and Breakfast",
    "Deluxe A/C Single Room With Breakfast",
    "Deluxe AC Room - Single Occupancy - With Breakfast",
    "Deluxe AC Single With Breakfast",
    "Deluxe Double Room With Breakfast",
    "Deluxe Double Room with Breakfast",
    "Deluxe Double Room with Breakfast MOR",
    "Deluxe Double Room With Breakfast-MOR",
    "Deluxe Double Room with Breakfast - Special Rate",
    "Deluxe Double with Breakfast",
    "Deluxe King Room Single With Breakfast",
    "Deluxe King Room with Breakfast",
    "Deluxe King Single Room With Breakfast",
    "Deluxe Queen Room with Breakfast",
    "Deluxe Room with Breakfast",
    "Deluxe Room With Breakfast",
    "Deluxe Room with Breakfast - MOR",
    "Deluxe Room With Breakfast-MOR",
    "Deluxe Room with Breakfast - Single Occupancy",
    "Deluxe Single Room with Breakfast",
    "Deluxe Single Room With Breakfast",
    "Deluxe Single Room with Breakfast - MOR",
    "Deluxe Single Room With Breakfast-MOR",
    "Deluxe Single Room with Breakfast - Special Rate",
    "Deluxe Single with Breakfast",
    "Deluxe Single With Breakfast",
    "Deluxe Single With Breakfast - MOR",
    "Deluxe Twin Double Room - With Breakfast",
    "Deluxe Twin Room with Breakfast",
    "Deluxe Twin Single Room With Breakfast",
    "english buffet-Bed and Breakfast",
    "Executive Double Room With Breakfast",
    "Executive Double Room with Breakfast",
    "Executive Double Room With Breakfast - Special Rate",
    "Executive Double with Breakfast",
    "Executive Room Single with Breakfast",
    "Executive Room With Breakfast",
    "Executive Room with Breakfast - Single Occupancy",
    "Executive Single Room with Breakfast",
    "Executive Single Room With Breakfast",
    "Executive Single Room with Breakfast - MOR",
    "Executive Single Room With Breakfast-MOR",
    "Executive Single with Breakfast",
    "Flexible Rate with breakfast",
    "full buffet (hot and cold)-Bed and Breakfast",
    "Heritage Room with Breakfast",
    "hot buffet-Bed and Breakfast",
    "Luxury Single Room with Breakfast",
    "Meal Plan - Bed and Breakfast",
    "Premium Double Room with Breakfast",
    "Premium Single Room with Breakfast",
    "Premium Single Room With Breakfast",
    "Room with Breakfast",
    "Sea View with Breakfast",
    "Standard Double Room With Breakfast",
    "Standard Double Room with Breakfast",
    "Standard Room with Breakfast",
    "Standard Room With Breakfast",
    "Standard Single Room With Breakfast",
    "Standard Single Room with Breakfast",
    "Standard Single Room with Breakfast MOR Rate",
    "Standard Single with Breakfast",
    "Superior Double Room With Breakfast",
    "Superior Double Room with Breakfast",
    "Superior Double with Breakfast",
    "Superior Room with Breakfast",
    "Superior Room With Breakfast",
    "Superior Single Room with Breakfast",
    "Superior Single Room With Breakfast",
    "Superior Single with Breakfast",
    "Super Deluxe Double Room with Breakfast",
    "Super Deluxe Room with Breakfast",
    "Super Deluxe Single Room With Breakfast",
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })),
  "All Inclusive": [
    "All inclusive",
    "All Inclusion",
    "All inclusions",
    "All inclusive all",
    "All-inclusive (food/beverages/snacks)",
    "Bed and Breakfast-All Inclusion",
    "All Inclusive 1",
    "All Inclusive for 2",
    "All Inclusive For Two",
    "All Inclusive ( Non-Alcoholic )",
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })),
  "Full Board": [
    "Full Board",
    "Full Board - Plus",
    "Full Board (Alcohol Extra)",
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })),
  "Half Board": [
    "american-Half Board",
    "Bed and Breakfast-Half Board",
    "Half Board",
    "Half Board For Four",
    "Half Board For One",
    "Half Board For Three",
    "Half Board For Two",
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })),
  "Room Only": [
    "Boutique Single Room Only",
    "Budget Single Non AC Room Only",
    "Business Room Only",
    "City Deluxe Double Room Only",
    "Classic Room - Room Only",
    "Club Room Room Only",
    "Club Single Room Only",
    "Deluxe Double Room - Room Only",
    "Deluxe Double Room Only",
    "Deluxe Room Only",
    "Deluxe Room - Room Only",
    "Deluxe Single Room - Room Only",
    "Deluxe Single Room Only",
    "Deluxe Twin Double Room - Room Only",
    "Executive Double Room Only",
    "Executive Room Only",
    "Executive Single - Room Only",
    "Executive Single Room Only",
    "Lodhi Standard Room Only",
    "Room Only",
    "Room Only - No meal plan",
    "Room Only (No meals)",
    "Room Only - NRF",
    "Room Only (Room_Only)",
    "Room Only 2",
    "Room Only Promo",
    "Room Only Promo 1",
    "Room Only Promo 2",
    "Standard Double Room Only",
    "Standard Room Only",
    "Superior Double Room Only",
    "Superior Twin Bed Room Only",
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })),
};

// Transform API meal plan options to consolidate equivalent values and sort ASC
const transformMealPlanOptions = (
  apiOptions: MealPlanOption[]
): MealPlanOption[] => {
  const seen = new Set<string>();
  const result = Object.keys(mealPlanMapping).reduce(
    (acc: MealPlanOption[], representativeValue: string) => {
      if (
        apiOptions?.length > 0 && apiOptions.some((option) =>
          mealPlanMapping[representativeValue].includes(option.value)
        )
      ) {
        if (!seen.has(representativeValue)) {
          seen.add(representativeValue);
          acc.push({ label: representativeValue, value: representativeValue });
        }
      }
      return acc;
    },
    []
  );

  // Sort the result by label in ascending order (case-insensitive)
  return result.sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
  );
};

export { mealPlanMapping, transformMealPlanOptions };
